import React, { useEffect, useRef, useState } from "react";
import makeStyles from "@mui/styles/makeStyles";
import TableContainer from "@material-ui/core/TableContainer";
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  Tooltip,
  List,
  ListItem,
  ListItemText,
} from "@material-ui/core";
import { HelpOutline } from "@material-ui/icons";
import { Row, Col, Button, Alert } from "react-bootstrap";
import Select from "react-select";
import { Link } from "react-router-dom";
import { Form } from "react-bootstrap";
import { DecryptData } from "../DatosEncriptados/EncryptedFunctions";
import CheckRole from "../CheckRole";
import CircularProgress from "@mui/material/CircularProgress";
import MarimekkoChartComponent from "./MarimekkoChartComponent.js";
import AADService from "../funcionesAuth.js";

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Box,
} from "@mui/material";
import HistoricalEfectividadChart from "./newEvaluaciones/HistoricalEfectividadChart.js";
import HistoricalRiesgoResidualChart from "./newEvaluaciones/HistoricalRiesgoResidualChart.js";
import HistoricalRiesgoInherenteChart from "./newEvaluaciones/HistoricalRiesgoInherenteChart.js";
import { AdjuntosEvaluaciones } from "../Administracion/AdjuntosPath.js";
import { Field } from "formik";

function AlertDismissibleExample({ alerta }) {
  if (alerta === 1) {
    return <Alert variant="warning">Alerta</Alert>;
  } else if (alerta === 2) {
    return <Alert variant="success">Guardó exitosamente</Alert>;
  } else if (alerta === 3) {
    return <Alert variant="danger"></Alert>;
  } else if (alerta === 4) {
    return <Alert variant="warning">Error al enviar la información</Alert>;
  } else if (alerta === 5) {
    return <Alert variant="danger">Error en el servidor</Alert>;
  } else if (alerta === 6) {
    return (
      <Alert variant="warning">
        Ya existe una evaluación para el activo seleccionado
      </Alert>
    );
  } else {
    return <p></p>;
  }
}

const ActivateDesactivateModal = ({
  open,
  onClose,
  modalClasses,
  changeEvaluationStatus,
  setEvaluacion,
  evaluacion,
}) => {
  return (
    <Dialog open={open} sx={{ borderRadius: "10px" }}>
      <DialogTitle>
        {modalClasses === "activate"
          ? "La evaluación está desactivada"
          : "La evaluación está activada"}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          {modalClasses === "activate"
            ? "¿Está seguro que desea activar la evaluación?"
            : "¿Está seguro que desea desactivar la evaluación?"}
        </DialogContentText>
      </DialogContent>
      <Box display="flex" justifyContent="center">
        <DialogActions>
          <Button
            className="botonGeneral"
            onClick={() => {
              setEvaluacion({
                ...evaluacion,
                estado_evaluacion: true ? modalClasses === "activate" : false,
              });
              changeEvaluationStatus();
              onClose();
            }}
          >
            Entendido
          </Button>
        </DialogActions>
        <DialogActions>
          <Button className="botonGeneral" onClick={onClose}>
            Cancelar
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
};

const EditarEvaluacion = () => {
  const useStyles = makeStyles({
    table: {
      minWidth: 650,
    },
  });

  const getColor = (index) => {
    const colors = [
      "#00C587",
      "#9F62D2",
      "#01CDEB",
      "#FF803A",
      "#2C2A29",
      "#FFB8D2",
    ];
    return colors[index % colors.length];
  };
  const [loading, setLoading] = React.useState(false);
  const [evaluacion, setEvaluacion] = useState([]);
  const [riesgos, setRiesgos] = useState([]);
  const [loadingHistorico, setLoadingHistorico] = React.useState(false);
  const [historicoinherente, setHistoricoInherente] = useState([]);
  const [historicoresidual, setHistoricoResidual] = useState([]);
  const [historicoefectividad, setHistoricoEfectividad] = useState([]);
  const [risk, setRisk] = useState("residual");
  const check = new CheckRole("/EditarEvaluacion");
  const [OpcionesGenerales, setOpcionesGenerales] = useState([]);
  const [currentRole, setCurrentRole] = useState(0);
  const [fileExists, setFileExists] = useState(false);
  const [fileUrl, setFileUrl] = useState(null);
  const [fileName, setFileName] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [analista_riesgos, setAnalistaRiesgos] = useState([]);
  const [dataActivo, setDataActivo] = useState([]);
  const idEvaluacion = localStorage.getItem("idevaluacion");
  const [responsable_TI, setResponsableTI] = useState("");
  const [responsable_negocio, setResponsableNegocio] = useState("");
  const [showHistorico, setShowHistorico] = useState(true);
  const [statusRequest, setStatusRequest] = useState(0);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [modalClasses, setModalClasses] = useState("activate");
  const AzureADService = new AADService();
  const token = AzureADService.getToken();
  const [estadoFlujo, setEstadoFlujo] = useState(evaluacion.estado_flujo || "En Proceso");
  const [fechaAprobacionActual, setFechaAprobacionActual] = useState(evaluacion.fechaaprobacion);
  const [archivoRecienSubido, setArchivoRecienSubido] = useState(false);
  const [modalAbierto, setModalAbierto] = useState(false);
  const [fileExistsAlAbrirModal, setFileExistsAlAbrirModal] = useState(false);

  const fetchDetalleEvaluacion = async () => {
    setLoading(true);
    const result = await fetch(
      process.env.REACT_APP_API_URL +
      "evaluacion/newdetalleevaluacion/" +
      localStorage.getItem("idcompania") +
      "/" +
      localStorage.getItem("idevaluacion") +
      "/",
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + token,
        },
      }
    );
    if (result.status >= 200 && result.status <= 300) {
      let data = await result.json();
      const { tipo_despliegue, tipo_canal, old_idtipo_activo } = data;
      tipo_despliegue
        ? localStorage.setItem("variable_tipo_despliegue", tipo_despliegue)
        : localStorage.removeItem("variable_tipo_despliegue");
      tipo_canal
        ? localStorage.setItem("variable_tipo_canal", tipo_canal)
        : localStorage.removeItem("variable_tipo_canal");
      old_idtipo_activo
        ? localStorage.setItem("variable_old_tipo_activo", old_idtipo_activo)
        : localStorage.removeItem("variable_old_tipo_activo");
      let dataCanal,
        dataDespliegue = "";
      if (!tipo_despliegue && !tipo_canal) {
        //Si dataStorageTipoDesp-canal no existe
        dataCanal = "No asociado";
        dataDespliegue = "No asociado";
      } //Si localStorage.getItem("variable_tipo_despliegue") contiene una ","
      else if (tipo_despliegue.includes(",")) {
        const Stipo_despliegue = tipo_despliegue.split(",");
        dataDespliegue = Stipo_despliegue.join(", ");
        dataCanal = tipo_canal;
      } else {
        dataDespliegue = tipo_despliegue;
        dataCanal = tipo_canal;
      }
      setEvaluacion({
        ...data,
        tipo_canal: dataCanal,
        tipo_despliegue: dataDespliegue,
      });

      let datos = data;
      if (datos.validadorero == "TI") {
        fetchUsuarioTI(datos.responsableti);
        fetchUsuarioNeg(datos.responsablenegocio);
      } else if (datos.validadorero == "Negocio") {
        fetchUsuarioNeg(datos.responsablenegocio);
        fetchUsuarioTI(datos.responsableti);
      } else {
        fetchUsuarioTI(datos.responsableti);
        fetchUsuarioNeg(datos.responsablenegocio);
      }
      setLoading(false);
      return data;
    } else if (result.status >= 400 && result.status <= 500) {
      return result.status;
    }
  };
  const updateFindings = async () => {
    const result = await fetch(
      process.env.REACT_APP_API_URL +
      "maestro/findings/update/" +
      localStorage.getItem("idactivo") +
      "/",
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + token,
        },
      }
    );
    if (result.status >= 200 && result.status <= 300) {
      let data = await result.json();
      alert(data["message"]);
    } else if (result.status >= 400 && result.status <= 500) {
      alert("No se encontraron findings en esta evaluación");
    }
  };

  const Ontologia = async () => {
    const result = await fetch(
      process.env.REACT_APP_API_URL +
      "maestro/modeloAmenaza/" +
      localStorage.getItem("idevaluacion") +
      "/" +
      localStorage.getItem("idcompania"),
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + token,
        },
      }
    );
    if (result.status >= 200 && result.status <= 300) {
      alert("Ontología actualizada correctamente");
    } else if (result.status == 409) {
      alert("Las vulnerabilidades no tienen cve asociado");
    } else if (result.status >= 400 && result.status <= 500) {
      alert("Error al actualizar la ontología");
    }
  };

  const fetchHistoricoEvaluacion = async () => {
    setLoadingHistorico(true);
    try {
      const result = await fetch(
        process.env.REACT_APP_API_URL +
        "evaluacion/newhistorico/" +
        localStorage.getItem("idevaluacion") +
        "/",
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
          },
        }
      );

      if (result.status === 200) {
        const data = await result.json();

        const dataihnerente = data.map((item) => ({
          idriesgo: item.idriesgo,
          exposicioninherentep95: item.exposicioninherentep95,
          fechamodificacion: item.fechamodificacion,
        }));

        const dataresidual = data.map((item) => ({
          idriesgo: item.idriesgo,
          exposicionresidual: item.exposicionresidual,
          fechamodificacion: item.fechamodificacion,
        }));

        const dataefectividad = data.map((item) => ({
          idriesgo: item.idriesgo,
          efectividadcontrol: item.efectividadcontrol,
          fechamodificacion: item.fechamodificacion,
        }));

        setHistoricoInherente(dataihnerente);
        setHistoricoResidual(dataresidual);
        setHistoricoEfectividad(dataefectividad);
      } else {
        setHistoricoInherente([]);
        setHistoricoResidual([]);
        setHistoricoEfectividad([]);
      }
    } catch (error) {
      setHistoricoInherente([]);
      setHistoricoResidual([]);
      setHistoricoEfectividad([]);
    }
  };

  const fetchRiesgosEvaluacion = async () => {
    const result = await fetch(
      process.env.REACT_APP_API_URL +
      "evaluacion/newriesgos/" +
      localStorage.getItem("idevaluacion") +
      "/",
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + token,
        },
      }
    );
    let data = await result.json();
    data.sort((a, b) => a.idriesgo - b.idriesgo);
    setRiesgos(data);
  };

  const fetchUsuario = async () => {
    const result = await fetch(
      process.env.REACT_APP_API_URL +
      "usuarios/menu/" +
      localStorage.getItem("usuario") +
      "/",
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + token,
        },
      }
    );
    const encryptedUser = await result.json();
    const decryptedUser = DecryptData(encryptedUser);
    let usuario = JSON.parse(decryptedUser);
    let opciones = [];
    let permisos = [];
    for (let i = 0; i < usuario.length; i++) {
      permisos = usuario[i].permisos.split(";");
      opciones.push({ opcion: usuario[i].url_opcion, permisos: permisos });
    }
    setOpcionesGenerales(opciones);
    setCurrentRole(usuario[0].idrol);
  };

  // const fetchAdjuntos = async () => {
  //   const url = `${
  //     process.env.REACT_APP_API_URL
  //   }administrador/adjuntos/ERO/${localStorage.getItem("idevaluacion")}/`;
  //   try {
  //     const response = await fetch(url, {
  //       method: "GET",
  //       headers: {
  //         //'Authorization': "Bearer " + token,
  //       },
  //     });
  //     if (response.ok) {
  //       setFileExists(true);
  //       const blob = await response.blob();
  //       const contentDisposition = response.headers.get("Content-Disposition");
  //       const fileNameMatch =
  //         contentDisposition && contentDisposition.match(/filename="([^"]+)"/);
  //       const fileName = fileNameMatch
  //         ? fileNameMatch[1]
  //         : `ERO_${localStorage.getItem("idevaluacion")}`;
  //       const fileNameEncoded = encodeURIComponent(fileName);
  //       const downloadUrl = window.URL.createObjectURL(blob);
  //       setFileUrl(downloadUrl);
  //       setFileName(fileNameEncoded);
  //     } else {
  //       setFileExists(false);
  //       setFileUrl(null);
  //       console.error("File not found");
  //     }
  //   } catch (error) {
  //     console.error("Error checking file existence:", error);
  //   }
  // };

  const fetchUsuariosRoti = async () => {
    const result = await fetch(
      process.env.REACT_APP_API_URL + "usuariosroti/",
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + token,
        },
      }
    );
    let param = await result.json();
    setAnalistaRiesgos(param);
  };

  const fetchUsuarioTI = async (posicion) => {
    const resultTI = await fetch(
      process.env.REACT_APP_API_URL +
      "usuariosrol/" +
      localStorage.getItem("idcompania") +
      "/5/",
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + token,
        },
      }
    );
    let paramTI = await resultTI.json();
    let usuario = paramTI.filter((u) => u.idposicion == posicion);
    try {
      setResponsableTI(usuario[0].nombre);
    } catch {
      setResponsableTI("");
    }
  };

  const fetchUsuarioNeg = async (posicion) => {
    const resultNeg = await fetch(
      process.env.REACT_APP_API_URL +
      "usuariosrol/" +
      localStorage.getItem("idcompania") +
      "/3/",
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + token,
        },
      }
    );
    let paramNeg = await resultNeg.json();
    let usuario = paramNeg.filter((u) => u.idposicion == posicion);
    try {
      setResponsableNegocio(usuario[0].nombre);
    } catch {
      setResponsableNegocio("");
    }
  };

  const CambioEstadoFlujo = (cambio) => {
    let timeElapsed = Date.now();
    let today = new Date(timeElapsed);

    let data;

    if (cambio === "Aprobada") {
      data = JSON.stringify({
        idevaluacion: evaluacion.idevaluacion,
        estado_flujo: "Aprobada",
        fechamodificacion: today.toISOString(),
        idusuariomodificacion: parseInt(localStorage.getItem("idusuario"), 10),
        fechaaprobacion: today.toISOString(),
      });
    } else if (cambio === "Pendiente Aprobación") {
      data = JSON.stringify({
        idevaluacion: evaluacion.idevaluacion,
        estado_flujo: "Pendiente Aprobación",
        fechaenvio: today.toISOString(),
        fechamodificacion: today.toISOString(),
        idusuariomodificacion: parseInt(localStorage.getItem("idusuario"), 10),
      });
    } else {
      data = JSON.stringify({
        idevaluacion: evaluacion.idevaluacion,
        estado_flujo: "En proceso",
        fechamodificacion: today.toISOString(),
        idusuariomodificacion: parseInt(localStorage.getItem("idusuario"), 10),
      });
    }

    fetch(
      process.env.REACT_APP_API_URL +
      "evaluacion/cambioestadoflujo/" +
      localStorage.getItem("idevaluacion") +
      "/",
      {
        method: "PUT",
        body: data,
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          Authorization: "Bearer " + token,
        },
      }
    ).then((response) => {
      if (response.status >= 200 && response.status < 300) {
        setStatusRequest(2);
      } else if (response.status >= 500) {
        setStatusRequest(5);
      } else if (response.status >= 400 && response.status < 500) {
        setStatusRequest(4);
      }
    });
  };

  const changeEvaluationStatus = (submit) => {
    let estado_evaluacion = modalClasses === "activate" ? true : false;
    let nombre_validador = document.getElementById("nombre_validador").value;
    let analista = document.getElementById("analista_riesgos");
    let idanalista = analista.options[analista.selectedIndex].value;
    let timeElapsed = Date.now();
    let today = new Date(timeElapsed);
    let data;

    let fechaAprobacionToSave = fechaAprobacionActual;
    if (evaluacion.estado_flujo !== "Aprobada" && estadoFlujo === "Aprobada") {
      fechaAprobacionToSave = today.toISOString().split("T")[0];
    } else if (estadoFlujo === "En Proceso") {
      fechaAprobacionToSave = fechaAprobacionActual;
    }

    if (submit === "submit") {
      data = JSON.stringify({
        idevaluacion: evaluacion.idevaluacion,
        estado_evaluacion: estado_evaluacion,
        idanalista: parseInt(idanalista, 10),
        validadorero: nombre_validador,
        fechamodificacion: today.toISOString().split("T")[0],
        estado_flujo: estadoFlujo,
        idusuariomodificacion: parseInt(localStorage.getItem("idusuario"), 10),
       
        ...(fechaAprobacionToSave && fechaAprobacionToSave.trim() !== '' && {
          fechaaprobacion: fechaAprobacionToSave
        })
      });
    } else {
      data = JSON.stringify({
        idevaluacion: evaluacion.idevaluacion,
        idanalista: parseInt(idanalista, 10),
        estado_evaluacion: estado_evaluacion,
        fechamodificacion: today.toISOString().split("T")[0],
        estado_flujo: estadoFlujo,
        idusuariomodificacion: parseInt(localStorage.getItem("idusuario"), 10),
    
        ...(fechaAprobacionToSave && fechaAprobacionToSave.trim() !== '' && {
          fechaaprobacion: fechaAprobacionToSave
        })
      });
    }

    fetch(
      process.env.REACT_APP_API_URL +
      "evaluacion/cambioestadoflujoEROnueva/" +
      localStorage.getItem("idevaluacion") +
      "/",
      {
        method: "PUT",
        body: data,
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          Authorization: "Bearer " + token,
        },
      }
    ).then((response) => {
      if (response.status >= 200 && response.status < 300) {
        setStatusRequest(2);
        // Actualizar los estados locales después del guardado exitoso
        setFechaAprobacionActual(fechaAprobacionToSave);
        // Actualizar el objeto evaluacion para reflejar los cambios
        setEvaluacion(prev => ({
          ...prev,
          estado_flujo: estadoFlujo,
          fechaaprobacion: fechaAprobacionToSave,
          fechamodificacion: today.toISOString().split("T")[0]
        }));
      } else if (response.status >= 500) {
        setStatusRequest(5);
      } else if (response.status >= 400 && response.status < 500) {
        setStatusRequest(4);
      }
    }).catch((error) => {
      console.error("Error al actualizar:", error);
      setStatusRequest(5);
    });
  };

  const fetchDataAdjuntos = async (isInitialLoad = false) => {
    const url = `${process.env.REACT_APP_API_URL}administrador/adjuntos/NewERO/${localStorage.getItem("idevaluacion")}/`;

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          'Authorization': "Bearer " + token,
        },
      });

      if (response.ok) {
        const blob = await response.blob();
        const contentDisposition = response.headers.get("Content-Disposition");

        let originalFileName = "archivo_sin_nombre";

        if (contentDisposition) {
          const patterns = [
            /filename\*=UTF-8''(.+)/,
            /filename\*=utf-8''(.+)/i,
            /filename="([^"]+)"/,
            /filename=([^;,\s]+)/,
          ];

          for (const pattern of patterns) {
            const match = contentDisposition.match(pattern);
            if (match) {
              try {
                originalFileName = decodeURIComponent(match[1].replace(/['"]/g, ''));
                break;
              } catch (error) {
                originalFileName = match[1].replace(/['"]/g, '');
              }
            }
          }
        }

        const downloadUrl = window.URL.createObjectURL(blob);

        // Estados previos para comparación
        const previousFileExists = fileExists;

        setFileUrl(downloadUrl);
        setFileName(originalFileName);
        setFileExists(true);

        // Solo validar si NO es la carga inicial y antes no existía archivo
        if (!isInitialLoad && !previousFileExists && !modalAbierto) {
          console.log("Archivo NUEVO detectado fuera del modal - cambiando estado visual");
          handleAutomaticValidation();
        } else if (isInitialLoad) {
          console.log("Carga inicial - archivo existente detectado, NO se valida automáticamente");
        }

        return true;
      } else {
        setFileExists(false);
        setFileUrl(null);
        setFileName(null);
        return false;
      }
    } catch (error) {
      console.error("Error fetching file:", error);
      setFileExists(false);
      setFileUrl(null);
      setFileName(null);
      return false;
    }
  };


  useEffect(() => {
    const fetchData = async () => {
      const evaluacionData = await fetchDetalleEvaluacion();
      localStorage.setItem(
        "variable_tipo_activo",
        evaluacionData.idtipo_activo
      );

      // Inicializar estados locales
      setEstadoFlujo(evaluacionData.estado_flujo || "En Proceso");
      setFechaAprobacionActual(evaluacionData.fechaaprobacion);

      const result2 = await fetch(
        process.env.REACT_APP_API_URL +
        "activoInformacion/" +
        evaluacionData.idactivo +
        "/",
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
          },
        }
      );
      const encryptedparam = await result2.json();
      const decryptedparam = DecryptData(encryptedparam);
      let param = JSON.parse(decryptedparam);
      setDataActivo(param);
      localStorage.setItem("alcance_corporativo", param.alcance_corporativo);
      localStorage.setItem("id_activo", evaluacionData.idactivo);
    };

    fetchData();
    fetchHistoricoEvaluacion();
    fetchRiesgosEvaluacion();
    fetchUsuario();
    fetchDataAdjuntos(); // Esta llamada inicial verificará archivos existentes
    fetchUsuariosRoti();
    fetchUsuarioTI(5);
    fetchUsuarioNeg(3);
  }, [])

  const handleAutomaticValidation = () => {
    console.log("Ejecutando validación visual...");

    if (estadoFlujo !== "Aprobada") {
      console.log("Cambiando estado visualmente de", estadoFlujo, "a Aprobada (sin guardar)");
      setEstadoFlujo("Aprobada");
    } else {
      console.log("El estado ya era Aprobada");
    }
  };

  useEffect(() => {
    if (modalAbierto && fileExists) {
      if (!fileExistsAlAbrirModal && !archivoRecienSubido) {
        console.log("Archivo NUEVO detectado durante sesión del modal");
        setArchivoRecienSubido(true);
      } else if (!fileExistsAlAbrirModal) {
        console.log("Archivo ya existía al abrir modal - no es nuevo");
      }
    }
  }, [fileExists, modalAbierto, fileExistsAlAbrirModal, archivoRecienSubido]);

  const handleShow = () => {
    console.log("Abriendo modal...");
    setFileExistsAlAbrirModal(fileExists);
    console.log("Estado de archivo al abrir modal:", fileExists);
    setShowModal(true);
    setModalAbierto(true);
    setArchivoRecienSubido(false);
  };

  // Función mejorada para cerrar modal
  const handleClose = () => {
    console.log("Cerrando modal...");
    console.log("¿Había archivo al abrir?", fileExistsAlAbrirModal);
    console.log("¿Hay archivo ahora?", fileExists);
    console.log("¿Se marcó como recién subido?", archivoRecienSubido);

    setShowModal(false);

    // Si se subió un archivo nuevo desde el modal, cambiar estado visual
    const seSubioArchivoNuevo = archivoRecienSubido || (!fileExistsAlAbrirModal && fileExists);
    if (seSubioArchivoNuevo && estadoFlujo !== "Aprobada") {
      console.log("Archivo nuevo detectado - cambiando estado visual a Aprobada");
      setEstadoFlujo("Aprobada");
    }

    setModalAbierto(false);
    setArchivoRecienSubido(false);
    setFileExistsAlAbrirModal(false);
    refreshAdjuntos();
  };

  let opciones_validadorero = ["Negocio", "TI", "Mixto"];

  const handleFileUploadSuccess = async () => {
    console.log("handleFileUploadSuccess ejecutándose desde modal...");
    setArchivoRecienSubido(true);

    try {
      // Refrescar información de archivos
      await fetchDataAdjuntos();

      // Cambiar estado visual si no está aprobado
      if (estadoFlujo !== "Aprobada") {
        console.log("Archivo subido desde modal - cambiando estado visual a Aprobada");
        setEstadoFlujo("Aprobada");
      }
    } catch (error) {
      console.error("Error en handleFileUploadSuccess:", error);
    }
  };

  const refreshAdjuntos = async () => {
    try {
      await fetchDataAdjuntos();
      console.log("Archivos actualizados - refresh manual");
    } catch (error) {
      console.error("Error actualizando archivos:", error);
    }
  };

  const handleEstadoFlujoChange = (nuevoEstado) => {
    setEstadoFlujo(nuevoEstado);
  };

  return (
    <div>
      <AlertDismissibleExample alerta={statusRequest} />
      <AdjuntosEvaluaciones
        show={showModal}
        onHide={handleClose}
        fileExists={fileExists}
        elemento={"NewERO"}
        idElemento={localStorage.getItem("idevaluacion")}
        onFileUploadSuccess={handleFileUploadSuccess}
      />
      {loading ? (
        <div
          style={{ display: "flex", justifyContent: "center", width: "100%" }}
        >
          <CircularProgress />
        </div>
      ) : (
        <div>
          <Row className="row_n_eval">
            <Col md={4}>
              <h2 className="estilo_titulos">Nueva Evaluación de Riesgos</h2>
            </Col>
            <Col md={2}>
              {currentRole == 1 ? (
                <Button
                  className="botonGeneral"
                  onClick={() => {
                    updateFindings();
                  }}
                >
                  Actualizar Findings
                </Button>
              ) : (
                ""
              )}
            </Col>
            <Col md={1}>{""}</Col>
            <Col md={2}>
              {currentRole == 1 ? (
                <Button
                  className="botonGeneral"
                  onClick={() => {
                    Ontologia();
                  }}
                >
                  Actualizar Ontología
                </Button>
              ) : (
                ""
              )}
            </Col>
          </Row>
          <hr />
          <Row className="row_n_eval">
            <Col md={3}>
              <label className="label">Id Evaluación</label>
            </Col>
            <Col md={3}>
              <label className="texto">{evaluacion.idevaluacion}</label>
            </Col>
            <Col md={3}>
              <label className="label">Id Activo</label>
            </Col>
            <Col md={3}>
              <label className="texto">{evaluacion.idactivo}</label>
            </Col>
          </Row>
          <Row className="row_n_eval">
            <Col md={3}>
              <label className="label">Activo a evaluar</label>
            </Col>
            <Col md={3}>
              <label className="texto">{evaluacion.nombre}</label>
            </Col>
            <Col md={3}>
              <label className="label">Código App</label>
            </Col>
            <Col md={3}>
              <label className="texto">
                {evaluacion.elemento_configuracion}
              </label>
            </Col>
          </Row>
          <Row className="row_n_eval">
            <Col md={3}>
              <label className="label">Estado de la Evaluación</label>
            </Col>
            <Col md={3} className="d-flex">
              <label className="label">
                {evaluacion.estado_evaluacion === 1
                  ? "Activa"
                  : evaluacion.estado_evaluacion === 2
                    ? "Inactiva"
                    : ""}
              </label>
            </Col>
            <Col md={3}>
              <label className="label">Tipo de activo a evaluar</label>
            </Col>
            <Col md={3}>
              <label className="texto">{evaluacion.tipo_activo}</label>
            </Col>
          </Row>
          <Row className="row_n_eval">
            <Col md={3}>
              <label className="label">Fecha de Creación</label>
            </Col>
            <Col md={3}>
              <label className="texto">{evaluacion.fechacreacion}</label>
            </Col>
            <Col md={3}>
              <label className="label">Tipo de Despliegue</label>
            </Col>
            <Col md={3}>
              <label className="texto">{evaluacion.tipo_despliegue}</label>
            </Col>
          </Row>
          <Row className="row_n_eval">
            <Col md={3}>
              <label className="label">Fecha de Modificación</label>
            </Col>
            <Col md={3}>
              <label className="texto">
                {evaluacion.fechamodificacion
                  ? evaluacion.fechamodificacion.split("T")[0]
                  : ""}
              </label>
            </Col>
            <Col md={3}>
              <label className="label">Estado del flujo</label>
            </Col>
            <Col md={3}>
              <label className="texto">

                {estadoFlujo === "Pendiente Aprobación"
                  ? "Pendiente Validación"
                  : estadoFlujo === "Aprobada"
                    ? "Validada"
                    : "En Proceso"}
                {/* Indicador visual si hay cambios pendientes */}
                {estadoFlujo !== evaluacion.estado_flujo && (
                  <span style={{ color: 'orange', marginLeft: '5px' }}>
                    (cambios no guardados evaluacion "En Proceso")
                  </span>
                )}
              </label>
            </Col>
          </Row>
          <Row className="row_n_eval">
            <Col md={3}>
              <label className="label">Fecha de Aprobación</label>
            </Col>
            <Col md={3}>
              <label className="texto">
                {fechaAprobacionActual
                  ? fechaAprobacionActual.split("T")[0]
                  : ""}
              </label>
            </Col>
          </Row>
          <Row className="row_n_eval">
            <Col md={3}>
              <label className="label">¿Es BIA?</label>
            </Col>
            <Col md={3}>
              <label className="texto">{dataActivo.bia ? "Sí" : "No"}</label>
            </Col>
            <Col md={3}>
              <label className="label">¿Es SOX?</label>
            </Col>
            <Col md={3}>
              <label className="texto">{dataActivo.sox ? "Sí" : "No"}</label>
            </Col>
          </Row>
          <Row className="row_n_eval">
            <Col md={3}>
              <label className="label">Tipo de Canal</label>
            </Col>
            <Col md={3}>
              <label className="texto">{evaluacion.tipo_canal}</label>
            </Col>
            <Col md={3}>
              <label className="label">Evidencia de validación</label>
            </Col>
            <Col md={3}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <Button
                  onClick={handleShow}
                  disabled={
                    (currentRole !== 1 && currentRole !== 2) ||
                    (evaluacion.estado_flujo !== "Pendiente Aprobación" &&
                      evaluacion.estado_flujo !== "En proceso")
                  }
                >
                  {fileExists ? "Cambiar archivo" : "Cargar archivo"}
                </Button>

                {fileExists && fileUrl && fileName && (
                  <a
                    href={fileUrl}
                    download={fileName}
                    style={{
                      textDecoration: 'none',
                      color: '#007bff',
                      padding: '5px 10px',
                      border: '1px solid #007bff',
                      borderRadius: '4px',
                      fontSize: '14px',
                      backgroundColor: '#f8f9fa'
                    }}
                  >
                    📁{fileName}
                  </a>
                )}
              </div>
            </Col>
          </Row>
          <hr />
          <Row className="row_n_eval">
            <Col md={3}>
              <label className="label">Analista de riesgos</label>
            </Col>
            <Col md={3}>
              <select
                className="form-control"
                title="analista riesgos"
                id="analista_riesgos"
                value={evaluacion.idanalistaresponsable || ""}
                onChange={(e) => {
                  setEvaluacion({
                    ...evaluacion,
                    idanalistaresponsable: e.target.value,
                  });
                }}
              >
                <option value="" disabled>
                  Analista No Definido
                </option>
                {analista_riesgos.map((item) => (
                  <option key={item.idusuario} value={item.idusuario}>
                    {item.nombre}
                  </option>
                ))}
              </select>
            </Col>
            <Col md={3}>
              <label className="label">Validador ERO</label>
            </Col>
            <Col md={3}>
              <select
                className="form-control"
                title="Tipo de activo"
                id="nombre_validador"
                value={evaluacion.validadorero || ""}
                onChange={(e) => {
                  setEvaluacion({
                    ...evaluacion,
                    validadorero: e.target.value,
                  });
                }}
              >
                {opciones_validadorero.map((item) => (
                  <option key={item} value={item}>
                    {item}
                  </option>
                ))}
              </select>
            </Col>
          </Row>
          <Row className="row_n_eval">
            <Col md={3}>
              <label className="label">Responsable del Negocio</label>
            </Col>
            <Col md={3}>
              <label id="responsable_negocio" className="texto">
                {evaluacion.nombreresponsablenegocio}
              </label>
            </Col>
            <Col md={3}>
              <label className="label">Responsable en TI</label>
            </Col>
            <Col md={3}>
              <label id="responsable_TI" className="texto">
                {evaluacion.nombreresponsableti}
              </label>
            </Col>
          </Row>
          {dataActivo.alcance_corporativo == "1" ? (
            <Row className="mb">
              <Col className="text-center">
                <p className="label forn-label" style={{ color: "red" }}>
                  El activo a evaluar es de alcance corporativo, recuerde
                  socializar con los equipos ROTIC de los países
                </p>
              </Col>
            </Row>
          ) : null}
          <Row className="clasicenter" style={{ marginTop: "4%" }}>
            <Col md={3}></Col>

            <Col md={3}>
              {check.checkPermits(OpcionesGenerales, "PUT") ? (
                <Button
                  className="botonPositivo"
                  id="guardar_evaluacion"
                  type="submit"
                  style={{ width: "100%" }}
                  onClick={() => {
                    changeEvaluationStatus("submit");
                  }}
                >
                  Guardar
                </Button>
              ) : (
                ""
              )}
            </Col>
          </Row>
          <br />
          <hr />
          <Row className="row_n_eval">
            <Col md={6}>
              <h2 className="estilo_titulos">Resumen de riesgos</h2>
            </Col>
          </Row>
          <Paper>
            <TableContainer>
              <Table
                stickyHeader
                aria-labelledby="tableTitle"
                size={"medium"}
                aria-label="enhanced table"
              >
                <TableHead>
                  <TableRow>
                    <TableCell></TableCell>
                    <TableCell>ID Riesgo</TableCell>
                    <TableCell>Evento</TableCell>
                    <TableCell>Característica de seguridad</TableCell>
                    <TableCell>Riesgo Inherente</TableCell>
                    <TableCell>Efectividad Control</TableCell>
                    <TableCell>Riesgo Residual</TableCell>
                    <TableCell>Criticidad</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {riesgos.map((row, index) => (
                    <TableRow key={index}>
                      <TableCell>
                        <div
                          style={{
                            backgroundColor: getColor(index),
                            width: 20,
                            height: 20,
                            borderRadius: "50%",
                          }}
                        />
                      </TableCell>
                      <TableCell>{row.idriesgo}</TableCell>
                      <TableCell>{row.evento}</TableCell>
                      <TableCell>{row.caracteristica_seguridad}</TableCell>
                      <TableCell>{row.exposicioninherentep95}</TableCell>
                      <TableCell>
                        {row.efectividadcontrolmanual
                          ? row.efectividadcontrolmanual
                          : row.efectividadcontrol}
                      </TableCell>
                      <TableCell>{row.exposicionresidual}</TableCell>
                      <TableCell>{row.nivelriesgo}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
          <br />
          <hr />
          <br />
          {showHistorico ? (
            <>
              <Row>
                <Select
                  options={[
                    { value: "inherente", label: "Inherente" },
                    { value: "residual", label: "Residual" },
                  ]}
                  placeholder="Seleccione tipo"
                  onChange={(e) => {
                    setRisk(e.value);
                  }}
                  defaultValue={{ value: "residual", label: "Residual" }}
                />
              </Row>
              <Row>
                <Col md={6} sm={12}>
                  {risk === "residual" ? (
                    <HistoricalRiesgoResidualChart
                      historicoresidual={historicoresidual}
                      getColor={getColor}
                    />
                  ) : (
                    <HistoricalRiesgoInherenteChart
                      historicoinherente={historicoinherente}
                      getColor={getColor}
                    />
                  )}
                </Col>
                <Col md={6} sm={12}>
                  <HistoricalEfectividadChart
                    historicoefectividad={historicoefectividad}
                    getColor={getColor}
                  />
                </Col>
              </Row>
            </>
          ) : (
            <Alert variant="info">No hay datos históricos para mostrar</Alert>
          )}
          <br />
          <hr />
          <br />
          <Row>
            <Col sm={12} xs={12}>
              <MarimekkoChartComponent />
            </Col>
          </Row>
          {openEditModal && (
            <ActivateDesactivateModal
              open={openEditModal}
              onClose={() => setOpenEditModal(false)}
              modalClasses={modalClasses}
              changeEvaluationStatus={changeEvaluationStatus}
              setEvaluacion={setEvaluacion}
              evaluacion={evaluacion}
            />
          )}
        </div>
      )
      }
    </div >
  );
};

export default EditarEvaluacion;
